mutation PublishVariationsXmlFeed(
    $campaignId: ID!
    $platform: String!
    $computedDeliverableIdentifiers: [InputComputedDeliverableIdentifier]
    $libraryFilters: InputLibraryFilters
    $isRendering: Boolean
    $rebuild: Boolean
) {
    publishVariationsXmlFeed(
        campaignId: $campaignId
        platform: $platform
        computedDeliverableIdentifiers: $computedDeliverableIdentifiers
        libraryFilters: $libraryFilters
        isRendering: $isRendering
        rebuild: $rebuild
    )
}
